module.exports = __webpack_public_path__ + "checkmark.png";